"use client";

export const HeroVSL = () => {
  return (
    <section
      className="relative flex overflow-hidden"
      aria-label="Seção principal com VSL do Método LDA"
    >
      {/* Background animado */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-primary">
        <div className="absolute top-20 left-20 w-96 h-96 bg-primary/30 rounded-full blur-[100px] motion-safe:animate-glow-pulse" />
        <div
          className="absolute bottom-20 right-20 w-96 h-96 bg-accent/20 rounded-full blur-[100px] motion-safe:animate-glow-pulse"
          style={{ animationDelay: "2s" }}
        />
      </div>

      {/* Conteúdo central */}
      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="mx-auto max-w-7xl flex flex-col items-center gap-8 sm:gap-10">
          {/* Título CHAMATIVO acima da VSL */}
          <header className="w-full text-center space-y-4">
            <h1 className="text-5xl sm:text-3xl md:text-4xl lg:text-5xl font-black leading-[1.05] tracking-tight">
              ACABE COM SEU VÍCIO EM APOSTAS HOJE MESMO E
              <br />
              <span className="bg-gradient-accent bg-clip-text text-transparent drop-shadow-[0_0_25px_rgba(100,192,242,0.65)]">
                TENHA SUA VIDA DE VOLTA!
              </span>
            </h1>
          </header>

          {/* VSL GRANDONA “na cara” */}
          <div className="relative w-full">
            {/* Glow de fundo do card */}
            <div className="pointer-events-none absolute inset-0 -z-10 bg-gradient-radial from-primary/40 via-accent/20 to-transparent blur-3xl" />

            {/* Wrapper com borda de vidro */}
            <div className="mx-auto w-full max-w-[1400px] group motion-safe:animate-scale-in">
              <div className="relative rounded-3xl p-1 sm:p-1.5 bg-gradient-to-br from-primary/30 via-card/20 to-accent/30">
                <div className="relative aspect-video w-full rounded-[1.25rem] overflow-hidden backdrop-blur-xl bg-card/40 border border-white/10 hover:border-primary/40 transition-all duration-500 hover:shadow-[0_0_80px_rgba(100,192,242,0.30)]">
                  <div className="relative aspect-video">
                    <iframe
                      src="https://customer-zp8wihilpijk0agl.cloudflarestream.com/0b4a5eaddb521e6c82047808e4af21da/iframe?autoplay=true&poster=https%3A%2F%2Fcustomer-zp8wihilpijk0agl.cloudflarestream.com%2F0b4a5eaddb521e6c82047808e4af21da%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600"
                      loading="lazy"
                      title="VSL - Método LDA"
                      className="absolute inset-0 h-full w-full"
                      style={{ border: "none" }}
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                </div>
              </div>

              {/* Glow ao redor no hover */}
              <div className="pointer-events-none absolute -inset-4 -z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-gradient-radial from-primary/25 via-accent/10 to-transparent blur-3xl" />
            </div>
          </div>
        </div>
      </div>

      {/* Sombra de base */}
      <div className="pointer-events-none absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent" />
    </section>
  );
};
